import React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  AlertStyled,
  FormFieldWrapperStyled,
} from 'components/common/initiate-proposal/styles';
import { useDDNJQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/ddnj/pageStore';
import { DDNJ_PROPOSAL_INFO_FORM_ID, DDNJ_SIC_WARNING_ALERT_TEST_ID } from './constants';

const DDNJQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions, sicWarningMessage },
    proposalInfoDelegate: { domainProductLineItems, isDomainProductLinesLoading },
    isStepCompleted,
  } = useDDNJQuoteProposalInfoPageStore();

  const showWarning = Boolean(sicWarningMessage);

  return (
    <IMFormStyled id={DDNJ_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled={isStepCompleted} />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled={isStepCompleted} />

      <FollowingSectionTitleStyled title="Additional Information" />
      <FormFieldWrapperStyled>
        <IMSicSearch label="SIC Code" size="full" disabled />
        <Collapse show={showWarning}>
          <AlertStyled
            content={[sicWarningMessage]}
            title="Note"
            type="warning"
            data-test-id={DDNJ_SIC_WARNING_ALERT_TEST_ID}
          />
        </Collapse>
      </FormFieldWrapperStyled>

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default DDNJQuoteProposalInfoForm;
